/**
 * @generated SignedSource<<851517914f61397e19ebfd8fbfb3cb0f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkerTypeFieldRefetchQuery$variables = {
  countryId?: number | null;
  industryId?: number | null;
};
export type WorkerTypeFieldRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"WorkerTypeField_viewer">;
  } | null;
};
export type WorkerTypeFieldRefetchQuery = {
  response: WorkerTypeFieldRefetchQuery$data;
  variables: WorkerTypeFieldRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 0,
    "kind": "LocalArgument",
    "name": "countryId"
  },
  {
    "defaultValue": 0,
    "kind": "LocalArgument",
    "name": "industryId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "countryId",
    "variableName": "countryId"
  },
  {
    "kind": "Variable",
    "name": "industryId",
    "variableName": "industryId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkerTypeFieldRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "FragmentSpread",
            "name": "WorkerTypeField_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkerTypeFieldRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "CountryWorkerType",
            "kind": "LinkedField",
            "name": "workerTypes",
            "plural": true,
            "selections": [
              {
                "alias": "workerTypeId",
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b30325ab8f8b0008796090d79a47f9fa",
    "id": null,
    "metadata": {},
    "name": "WorkerTypeFieldRefetchQuery",
    "operationKind": "query",
    "text": "query WorkerTypeFieldRefetchQuery(\n  $countryId: Int = 0\n  $industryId: Int = 0\n) {\n  viewer {\n    ...WorkerTypeField_viewer_4DIVIg\n  }\n}\n\nfragment WorkerTypeField_viewer_4DIVIg on Viewer {\n  workerTypes(countryId: $countryId, industryId: $industryId) {\n    workerTypeId: id\n    name\n    description\n  }\n}\n"
  }
};
})();

(node as any).hash = "7212d83a7eb511ddcacfe56978c68d92";

export default node;
